// extracted by mini-css-extract-plugin
module.exports = {"fo_box":"fo_box-1O7B-tyN"};